<template>
  <div v-if="networks.length > 0">
    <b-row>
      <b-col
        cols="12"
        class="mb-2"
      >
        <h3 class="mb-0">
          Select Network
        </h3>
        <small class="text-muted">
          Enter Network Details.
        </small>
      </b-col>
      <b-col
        cols="12"
      >
        <b-form-group
          label="Select Network"
          label-for="selectNetworkInput"
        >
          <v-select
            v-model="selectedNetwork"
            label="name"
            :options="networks"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-card
      v-if="selectedNetwork.name"
      :title="`Enter ${selectedNetwork.name} API Key`"
    >

      <b-row>
        <b-col
          cols="2"
        >
          <b-img
            :src="selectedNetwork.logoLink"
            thumbnail
            fluid
          />
        </b-col>

        <b-col
          cols="10"
        >

          <b-form-group
            label="API KEY"
            label-for="siteInput"
          >
            <validation-provider
              v-if="selectedNetwork.identifier !== 'virtual-network'"
              #default="{ errors }"
              name="API Key"
              rules="required"
            >
              <b-form-input
                id="APIKeyInput"
                v-model="networkDetails.api_key"
                :state="networkDetails.api_key.length > 0 "
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-button
            variant="primary"
            @click="validateApiKey"
          >
            Validate API Key
          </b-button>

          <b-row class="mt-2">
            <b-col>
              {{ validateResponse }}
            </b-col>
          </b-row>

        </b-col>
      </b-row>

    </b-card>
  </div>
</template>

<script>
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
import {
  BRow, BCol, BFormGroup, BImg, BTable, BCard, BFormInput, BButton,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import { API } from 'aws-amplify'
import axios from 'axios'
import * as queries from '../../../graphql/queries'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BImg,
    BButton,
    vSelect,
    ValidationProvider,
  },
  props: {
    networkDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      networks: [],
      validateResponse: '',
      selectedNetwork: {},
    }
  },
  created() {
    this.listNetworks()
  },
  methods: {
    async listNetworks() {
      await API.graphql({
        query: queries.listNetworks,
      }).then(response => {
        this.networks = response.data.listNetworks.items
      })
    },
    validateApiKey() {
      const url = 'https://console.helium.com/api/v1/organization'
      const config = {
        headers: {
          key: this.networkDetails.api_key,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
      axios.get(url, config)
        .then(response => {
          this.validateResponse = response
        })
    },
  },
}
</script>

<style>

</style>
